// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__OYV6Q","name":"ConsentHeader_name__3IJGO","birthday":"ConsentHeader_birthday__29PmS","skeleton":"ConsentHeader_skeleton__3CZlq"};